import { faNairaSign } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import Modal from "../../../layouts/seller-hub/Modal";
import Input from "./ModalInput";
import Button from "../buttons/Button";

const WithdrawModal = () => {
  const [amount, setAmount] = useState("");
  const [password, setPassword] = useState("");
  return (
    <Modal>
      <div className="mt-1">
        <h4 className="font-Inter font-medium text-lg text-[#69708D]">
          Available to withdraw
        </h4>
        <div className="flex items-center h-fit font">
          <FontAwesomeIcon icon={faNairaSign} className="text-lg mt-[2px]" />
          <p className="text-xl">90,000.00</p>
        </div>
        <form className="mt-5">
          <Input
            type="text"
            placeholder="Amount to withdraw"
            value={amount}
            onValueChange={setAmount}
          />
          <Input
            type="password"
            placeholder="Enter password"
            value={password}
            onValueChange={setPassword}
          />
          <div className="mt-10">
            <Button innerText="Initiate" width="w-full" />
          </div>
          <div className="flex gap-[1px] items-center mt-5">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-info text-[#02A443]"
              viewBox="0 0 16 16"
            >
              <path d="M8.93 6.588l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
            </svg>
            <p className="font-Lato text-sm text-sidenavInactive">
              Your fund will be deposited into your bank account
            </p>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default WithdrawModal;
